module.exports = __webpack_public_path__ + "img/noises-12.513bc172.jpg";